// import $ from 'jquery';

const PLUGIN_NAME = 'SearchDropdown';
import debug from "debug";
const log = debug(PLUGIN_NAME);
import debounce from './debounce';
import * as strings from './strings';

class SearchDropdown {
	constructor(element, options) {
		log('construct', element, options);

		this.options = options;
		this.element = element;
		this.$element = $(element);
		this.queryList=[];

		this.options.typingDebounceMs = parseInt(this.options.typingDebounceMs);

		this.options.escapeKeyCodes = this.options.escapeKeyCodes.split(' ');
		this.options.ignoreKeyCodes = this.options.ignoreKeyCodes.split(' ');

		this.hasFocus = false;
		this.focsusedElement = null;
		this.searchCancelled = false;

		this.searchField = $(this.options.searchInputSelector);
		this.submitButton = $(this.options.searchSubmitSelector);
		this.cancelButton = $(this.options.searchCancelSelector);
		this.resultsContainer = $(this.options.resultsContainerSelector);

		this.templateSource = $(this.options.dropdownTemplateSelector);
		this.template = this.templateSource.text();

		// Slurp up template and stick it into data
		// Not sure what problem this solves
		// Commented out as it prevents multiple search instances from sharing the template
		// this.templateSource.data('original-content', this.template);
		// this.templateSource.empty();

		window.strings = strings;

		this.watch();

		log('ready', this.$target);
	}

	watch() {
		const debounceImmediate = this.options.typingDebounceEdge === 'leading';
		this.searchField.on(
			'keyup',
			debounce(
				this.send.bind(this),
				this.options.typingDebounceMs,
				debounceImmediate
			)
		);

		// Respond to clear search button click (IE/Edge)
		this.searchField.on('mouseup', () => {
			const input = this.searchField;
			const oldValue = input.val();
			if (oldValue === '') {
				return false;
			}
			setTimeout(() => {
				const newValue = input.val();
				if (newValue === '') {
					this.cancel();
				}
			}, 0);

		});

		this.searchField.on('focusin', () => {
			this.open();
		});

		$(document).on('click', event => {
			const hasTarget = this.$element.has(event.target);
			if (hasTarget && hasTarget.length) {
				this.open();
			} else {
				this.close();
			}
		});

		this.cancelButton.on('click', () => {
			log('cancelClick');
			this.cancel();
		});

		log('watching');
	}

	addToQueryList(q,qid){
		this.queryList.push({
			queryId : qid,
			query : q,
			ignore:false,
			hasFinsihed:false
		});
	}

	removeFromQueryList(queryEl){
		// just make sure it exists and has finished
		var foundIndex = this.queryList.indexOf(queryEl);
		if(foundIndex>-1 && queryEl.hasFinsihed == true){
			this.queryList.splice(foundIndex,1);
		}
	}

	getQueryFromList(qid){
		return this.queryList.find(element => element.queryId ==qid);
	}

	setIgnoreForPreviousQueries(baseQuery){

		const indexOfCaseQuery= this.queryList.indexOf(baseQuery);

		for (let index = 0; index <indexOfCaseQuery ; index++) {
			const element = this.queryList[index];
				element.ignore=true;
		}
	}

	send(event) {
		log('send');
		this.close();
		const query = this.searchField.val();
		const { keyCode } = event;
		const {
			ignoreKeyCodes,
			escapeKeyCodes,
			minQueryLength,
			errorClass,
			sendingClass,
			openClass,
			url
		} = this.options;

		log('send', query);

		if (query && query.length < minQueryLength) {
			this.$element.trigger(`${PLUGIN_NAME}.notMinLength`);

			log('minQueryLength', query.length);
			return;
		} else if (ignoreKeyCodes.includes(''+keyCode)) {
			this.$element.trigger(`${PLUGIN_NAME}.keyIgnored`, { keyCode });

			log(
				`key[${
					event.keyCode
				}] ignored since it's in options.ignoreKeyCodes[${ignoreKeyCodes}]`
			);
			return;
		} else if (escapeKeyCodes.includes(''+event.keyCode)) {
			this.$element.trigger(`${PLUGIN_NAME}.escape`);
			log(
				`key[${
					event.keyCode
				}] triggered close since it's in options.escapeKeyCodes[${escapeKeyCodes}]`
			);

			this.close();
			return;
		} else if (query && query.length) {
			this.submitButton.addClass(this.options.buttonSubmittingClass);
			this.$element.trigger(`${PLUGIN_NAME}.beforeSend`);
			this.$element.addClass(sendingClass);
			this.$element.removeClass(errorClass);

			// add it to query list
			const queryId=(Date.now() + Math.random()).toString(36);
			this.addToQueryList(query,queryId);

			$.ajax({
				url,
				data: {
					q: query
				},
				success: (data, status, request) => {
					log('success', data, status);

					const successQuery= this.getQueryFromList(queryId);
					successQuery.hasFinsihed=true;
					if(successQuery.ignore == true){
						log('ignored success', data, status,successQuery);
					}
					else{
						this.$element.removeClass(errorClass);
						this.render(data);
						this.$element.addClass(openClass);
						this.$element.trigger(`${PLUGIN_NAME}.rendered`);
						this.setIgnoreForPreviousQueries(successQuery); // Set previous query results to be ignored if they show up later.
						this.removeFromQueryList(successQuery);// Finally remove query from list (don't want to overload the list)
					}
				},
				error: (data, status, request) => {
					log('error', data, status);

					this.$element.removeClass(openClass);
					this.$element.addClass(errorClass);
					this.$element.trigger(`${PLUGIN_NAME}.error`, {
						data,
						status,
						request
					});
				},
				complete: () => {
					this.$element.removeClass(sendingClass);
					this.submitButton.removeClass(this.options.buttonSubmittingClass);
				}
			});
		} else {
			this.cancel();
		}

		this.$element.trigger(`${PLUGIN_NAME}.afterSend`);
	}

	onFocusChanged(event) {
		log('onFocusChanged', event);
		this.focusedElement = event.toElement;
		const hasFocus = this.$element.has(this.focusedElement);
		this.hasFocus = hasFocus && hasFocus.length > 0;

		logger.log('onFocusIn.hasFocus', this.hasFocus);

		if (!this.hasFocus) {
			debounce(this.close.bind(this), 50);
		}
	}

	render(data) {
		log('render', data, this.template);
		const context = Object.keys(data).reduce((result, key) => {
			const value = data[key];
			result[key] = value;
			if (Array.isArray(value)) {
				result[`${key}IsEmpty`] = value.length === 0;
			}
			return result;
		}, {});
		const html = strings.mustache(this.template, context);
		log('rendered', html);
		this.resultsContainer.html(html);
	}

	reset(event) {
		log('reset');
		this.submitButton.removeClass(this.options.buttonSubmittingClass);
		this.searchField.val('');
		// this.searchField.emitOnDirty('clean'); // TODO - replace with non jquery
		this.resultsContainer.empty();
	}

	// Display suggestions
	open() {
		log('open');
		var items = this.$element.find(this.options.searchItemSelector);
		if(items.length > 0) {
			this.$element.addClass(this.options.openClass);
			// this.$element.trigger(`${PLUGIN_NAME}.open`);
		}
	}

	close() {
		log('close');
		this.$element.removeClass(this.options.hasErrorClass);
		this.$element.removeClass(this.options.sendingClass);
		this.$element.removeClass(this.options.openClass);
		this.$element.trigger(`${PLUGIN_NAME}.closed`);
	}

	cancel() {
		log('cancel');
		this.searchCancelled = true;
		this.reset();
		this.close();
	}
}

SearchDropdown.DEFAULTS = {
	/*
  http://keycode.info/
    9 = tab
    16 = shift
    17 = ctrl
    18 = alt
    37 = left
    38 = up
    39 = right
    40 = down
    32 = space
    91 = left super
    92 = right super
    //https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode#Constants_for_keyCode_value
  */
	minQueryLength: 3,
	ignoreKeyCodes: '9 16 17 18 33 34 35 36 37 38 39 40 44 91 92 93 224',
	escapeKeyCodes: '27',
	searchInputSelector: '[data-search-dropdown__input-field]',
	searchCancelSelector: '[data-search-dropdown__cancel-button]',
	searchSubmitSelector: '[data-search-dropdown__submit-button]',
	searchItemSelector: '[data-search-dropdown__item]',
	dropdownTemplateSelector: '#search-dropdown--template',
	resultsContainerSelector: '[data-search-dropdown__result-container]',
	typingDebounceMs: 500,
	typingDebounceEdge: 'trailing',
	openClass: 'search-dropdown--is-open',
	sendingClass: 'search-dropdown--is-sending',
	errorClass: 'search-dropdown--error',
	buttonSubmittingClass: 'is-submitting',
	placement: 'bottom',
	placementTarget: '(self)'
};

export default SearchDropdown;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/search-dropdown/search-dropdown.js